import { ACTION_TYPE_ROOT } from "../consts";

const makeAction = (actionType: string) => `${ACTION_TYPE_ROOT}${actionType}`;

const actionTypes = {
  RECEIVE_ASSIGNMENT: makeAction("RECEIVE_ASSIGNMENT"),
  RECEIVE_ASSIGNMENTS: makeAction("RECEIVE_ASSIGNMENTS"),
  DELETE_ASSIGNMENTS: makeAction("DELETE_ASSIGNMENTS"),
  UPDATE_ASSIGNMENT_SECTION_STAT: makeAction("UPDATE_ASSIGNMENT_SECTION_STAT"),
  UPDATE_ASSIGNMENT_QUESTION_STAT: makeAction(
    "UPDATE_ASSIGNMENT_QUESTION_STAT"
  ),
  UPDATE_ASSIGNMENT_QUIZ_STAT: makeAction("UPDATE_ASSIGNMENT_QUIZ_STAT"),
  UPDATE_ASSIGNMENT_VOCABULARY_STAT: makeAction(
    "UPDATE_ASSIGNMENT_VOCABULARY_STAT"
  )
};

export default actionTypes;
